module.exports = __webpack_public_path__ + "static/media/18.a541ee50.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/18.png
// module id = 870
// module chunks = 0